module.exports = __webpack_public_path__ + "img/info.70f07d53.png";